<template>
  <router-link
    v-slot="{
      href, navigate,
    }"
    :to="{
      name: ERouteName.HOME,
    }"
    custom
  >
    <a
      :href="href"
      :title="i18n.global.t('page.home.title')"
      @click="navigate"
    >
      <AichelinQmulusLockupSmall
        v-if="colorThemeBrand === 'aichelin'"
        style="width: 246px; height: 40px;"
      />
      <QmulusLogo
        v-else
        style="width: 177px; height: 40px;"
      />
    </a>
  </router-link>
</template>

<script setup lang="ts">
import {
  i18n,
} from '@i18n';
import AichelinQmulusLockupSmall from '@qmulus/ui/assets/aichelin-qmulus-lockup-small.svg';
import QmulusLogo from '@qmulus/ui/components/logo-qmulus/logo-qmulus.vue';

import {
  useAppearance,
} from '@/composition/use-appearance.ts';
import {
  ERouteName,
} from '@/router/route-name.ts';

const {
  colorThemeBrand,
} = useAppearance();
</script>
